export default __webpack_public_path__ + "static/product-reference-chart-tablet-4fc0d19e54de26d3b556162c8e3b62c6.png";